<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">Other Ways to Save for Retirement</h2>
    </header>

    <div class="row">
        <div class="col-md-5 mx-auto text-center">
            <p>This is coming soon with details on other ways to save for retirement.</p>
        </div>
    </div>
</template>
